import { useAtomValue } from 'jotai';
import { $CurrentAvailableExperienceDataOrNull } from '../atoms';
import { loadable } from 'jotai/utils';

export const useExperienceDesc = (): string => {
  const loadableCurrentAnswer = useAtomValue(loadable($CurrentAvailableExperienceDataOrNull));

  if (loadableCurrentAnswer.state !== 'hasData') {
    return '';
  }

  const data = loadableCurrentAnswer.data;

  if (!data) {
    return '';
  }
  const { answerContent, articleShortContent, isNewType } = data;

  return isNewType ? articleShortContent : `${answerContent[0].title}: ${answerContent[0].content}`;
};
